import React, { useState } from "react";
import { Space, Select, Button } from "antd";
import { DatePicker } from "../../components/antOverrides";
import { useParams, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import { listClientToCollect } from "../../api/server";
import { useDispatch, useSelector } from "react-redux";
import {
  setCategory,
  setClient,
  setBranch,
  setMonth,
  setYear,
  setPage,
  setClientsFlag,
} from "./paymentRequestsSlice";
import moment from "moment";
import { useQuery } from "react-query";
import _ from "lodash";
import { isAllowedFeature } from "../organization/organizationSlice";

const { Option } = Select;

const Header = (props) => {
  const { onCreatePaymentRequests, onPrintDemo, disabled, loading, items } =
    props;
  const intl = useIntl();
  let { branchId } = useParams();
  let location = useLocation();
  const dispatch = useDispatch();
  const [clientsList, setClientsList] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [activeDate, setActiveDate] = useState(moment().subtract(1, "months"));
  const profile = useSelector((state) => state.user.profile);
  const isAdmin = location.pathname.includes("admin");
  const activeClient = useSelector(
    (state) => state.paymentRequests.activeClient
  );
  const activeCategory = useSelector(
    (state) => state.paymentRequests.activeCategory
  );
  const activeYear = useSelector((state) => state.paymentRequests.activeYear);
  const activeMonth = useSelector((state) => state.paymentRequests.activeMonth);
  const activeBranch = useSelector(
    (state) => state.paymentRequests.activeBranch
  );
  const filtered_clients = useSelector(
    (state) => state.paymentRequests.clients
  );
  const branch = branchId || activeBranch;

  const { } = useQuery(
    [activeYear, activeMonth, branch],
    async () => {
      const params = { branch };
      if (activeMonth) {
        params["month"] = activeMonth;
      }
      if (activeYear) {
        params["year"] = activeYear;
      }
      const result = await listClientToCollect(params);
      const grouped = _.groupBy(result.data.items, "category_id");
      const cat = Object.keys(grouped).map((key) => ({
        ...grouped[key][0].category,
      }));
      setCategoriesList(cat);
      setClientsList(result.data.items);
      return result.data.items;
    },
    {
      keepPreviousData: true,
      staleTime: 0,
      enabled: branch !== null,
    }
  );

  const onClientChange = (val) => {
    dispatch(setClient({ client: val ? val : null }));
  };

  const onClientsFilterChange = (val) => {
    dispatch(setClientsFlag({ clients: val }));
  };

  const onCategoryChange = (val) => {
    dispatch(setCategory({ category: val }));
    dispatch(setClient({ client: null }));
  };

  const onBranchChange = (val) => {
    dispatch(setBranch({ branch: val }));
    dispatch(setCategory({ category: null }));
    dispatch(setClient({ client: null }));
    resetPage();
  };

  const onDateChange = (date, dateString) => {
    var month = date ? date.format("M") : null;
    var year = date ? date.format("YYYY") : null;
    dispatch(setMonth({ month: month }));
    dispatch(setYear({ year: year }));
    dispatch(setCategory({ category: null }));
    dispatch(setClient({ client: null }));
    resetPage();
    setActiveDate(date);
  };

  const resetPage = () => {
    const initialPage = {
      current: 1,
      pageSize: 10,
      filter: {
        freeText: null,
      },
      order: {},
      items: [],
    };
    dispatch(setPage({ ...initialPage }));
  };

  const clients = activeCategory
    ? clientsList.filter((i) => i.category_id === activeCategory)
    : [];

  const selectedCategory = categoriesList.find((i) => i.id === activeCategory);
  const suporting_community_exists = selectedCategory?.service_types?.some(
    (service) => service.supporting_community === true
  );
  const day_center_exists = selectedCategory?.service_types?.some(
    (service) => service.day_center === true
  );

  const isAllowedSupportingCommunity = isAllowedFeature("supporting_community");
  const isAllowedDayCenter = isAllowedFeature("day_center");

  const clientsFilterArr = [
    {
      name: intl.formatMessage({
        id: "app.prospectuses.clients_filter_home_service",
      }),
      value: 1,
    },
    ...(suporting_community_exists && isAllowedSupportingCommunity
      ? [
        {
          name: intl.formatMessage({
            id: "app.prospectuses.clients_filter_supporting_community",
          }),
          value: 2,
        },
      ]
      : []),
    ...(day_center_exists && isAllowedDayCenter
      ? [
        {
          name: intl.formatMessage({
            id: "app.prospectuses.clients_filter_day_center",
          }),
          value: 3,
        },
      ]
      : []),
  ];

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <Space direction="horizontal">
        <DatePicker
          value={activeDate}
          onChange={onDateChange}
          picker="month"
          format={"MM/YYYY"}
          placeholder={intl.formatMessage({
            id: `app.gaps.select_month`,
          })}
        />
        {isAdmin ? (
          <Select
            style={{ width: "200px" }}
            defaultValue={branchId ? parseInt(branchId) : undefined}
            showSearch
            placeholder={intl.formatMessage({
              id: "app.users.chooseBranch",
            })}
            optionFilterProp="children"
            onChange={onBranchChange}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            value={activeBranch}
          >
            {profile.branches.map((b) => (
              <Option value={b.id} key={b.id}>
                {b.name}
              </Option>
            ))}
          </Select>
        ) : null}
        <Select
          style={{ width: "fit-content", minWidth: "200px" }}
          showSearch
          placeholder={intl.formatMessage({
            id: "app.prospectuses.chooseClientCategory",
          })}
          optionFilterProp="children"
          onChange={onCategoryChange}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          value={activeCategory}
        >
          {categoriesList.map((b) => (
            <Option value={b.id} key={b.id}>
              {b.name}
            </Option>
          ))}
        </Select>
        <Select
          style={{ width: "fit-content", minWidth: "200px" }}
          showSearch
          allowClear
          placeholder={intl.formatMessage({
            id: "app.prospectuses.chooseClient",
          })}
          optionFilterProp="children"
          onChange={onClientChange}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          value={activeClient}
        >
          {clients.map((b) => (
            <Option value={b.id} key={b.id}>
              {b.name}
            </Option>
          ))}
        </Select>
        <Select
          style={{ width: "fit-content", minWidth: "200px" }}
          showSearch
          allowClear
          placeholder={intl.formatMessage({
            id: "app.prospectuses.chooseServiceType",
          })}
          optionFilterProp="children"
          onChange={onClientsFilterChange}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          mode="multiple"
          value={filtered_clients}
        >
          {clientsFilterArr.map((b) => (
            <Option value={b.value} key={b.name}>
              {b.name}
            </Option>
          ))}
        </Select>
      </Space>
      <Space>
        {items && items.length > 0 && (
          <Button type="text" onClick={onPrintDemo} loading={loading}>
            {intl.formatMessage({
              id: "app.prospectuses.printDemo",
            })}
          </Button>
        )}
        <Button
          disabled={disabled}
          type="primary"
          onClick={onCreatePaymentRequests}
          loading={loading}
        >
          {intl.formatMessage({
            id: "app.prospectuses.createPaymentRequest",
          })}
        </Button>
      </Space>
    </div>
  );
};

export default Header;
